import axios from 'axios';
import { validateEmail } from '../lib/validateEmail';
import { TDirectorInfo, TStep4Info } from '../types';
import { isEmailValid } from './validateEmail';
import { baseUrl_, timeout } from './constants';
import { encryptData, encryptEntrepreneurData } from './encryptJson';
import { toast } from 'react-toastify';
import { logUserOut } from './logUserOut';
import { decryptJson } from './decryptJson';
import { wqkgx } from '../config/keys';
import CryptoJS from 'crypto-js';
import customToast, { ToastType } from '../components_/Toast';

export const validateOwnersInput = (info: TStep4Info) => {
  const isfirstNameValid = info.firstName?.length > 0;
  const islastNameValid = info.lastName?.length > 0;
  const isBusinessEmailValid =
    validateEmail(info.businessEmail) || isEmailValid(info.businessEmail);
  const isOccupationValid = info.occupation?.length > 0;
  const isBvnValid = info.bvn && info.bvn?.length === 11;
  const isBvnPhoneValid = info.bvnPhone && info.bvnPhone?.length >= 10;
  const isNationalityValid = info.nationality?.length > 0;
  const isGenderValid = info.gender?.length > 0;
  const isIdentityTypeValid = info.identityType?.length > 0;
  const isIdentityNumberValid = info.identityNumber?.length > 0;
  return (
    isfirstNameValid &&
    islastNameValid &&
    isBusinessEmailValid &&
    isOccupationValid &&
    // isBvnValid &&
    isBvnPhoneValid &&
    isNationalityValid &&
    isGenderValid &&
    isIdentityTypeValid &&
    isIdentityNumberValid
  );
};

export const validateDirectorsInput = (directorInfo: TDirectorInfo) => {
  const isfirstNameValid = directorInfo.firstName?.length > 0;
  const islastNameValid = directorInfo.lastName?.length > 0;
  const isBusinessEmailValid =
    validateEmail(directorInfo.email) || isEmailValid(directorInfo.email);
  const isOccupationValid = directorInfo.occupation?.length > 0;
  const isphoneValid = directorInfo.phone && directorInfo.phone?.length === 11;
  const isNationalityValid = directorInfo.nationality?.length > 0;
  const isGenderValid = directorInfo.gender?.length > 0;
  const isIdentityNumberValid = directorInfo.identityNumber?.length === 11;
  const isBirthDateValid = directorInfo.birthDate ? true : false;

  return (
    isfirstNameValid &&
    islastNameValid &&
    isBusinessEmailValid &&
    isOccupationValid &&
    isphoneValid &&
    isNationalityValid &&
    isGenderValid &&
    isIdentityNumberValid &&
    isBirthDateValid
  );
};

export const validateShareholderInput = (shareholder: TDirectorInfo) => {
  const isfirstNameValid = shareholder.firstName?.length > 0;
  const islastNameValid = shareholder.lastName?.length > 0;
  const isBusinessEmailValid = validateEmail(shareholder.email) || isEmailValid(shareholder.email);
  const isOccupationValid = shareholder.occupation?.length > 0;
  const isphoneValid = shareholder.phone && shareholder.phone?.length === 11;
  const isNationalityValid = shareholder.nationality?.length > 0;
  const isGenderValid = shareholder.gender?.length > 0;
  const isIdentityNumberValid = shareholder.identityNumber?.length === 11;
  const isBirthDateValid = shareholder.birthDate ? true : false;
  const isSharesValid = shareholder.share ? true : false;
  const isBvnValid = shareholder.bvn && shareholder.bvn?.length === 11;

  return (
    isfirstNameValid &&
    islastNameValid &&
    isBusinessEmailValid &&
    isOccupationValid &&
    isphoneValid &&
    isNationalityValid &&
    isGenderValid &&
    isIdentityNumberValid &&
    isBirthDateValid &&
    isSharesValid
    // &&
    // isBvnValid
  );
};

type TBVNInput = {
  bvn: string;
  setLoadingBVNVerify: React.Dispatch<React.SetStateAction<boolean>>;
};

export const validateBVN = ({ bvn, setLoadingBVNVerify }: TBVNInput) => {
  const token = localStorage.getItem('login-token');

  setLoadingBVNVerify(true);
  axios
    .post(
      `${baseUrl_}/verify/bvn`,
      encryptData({
        bvn: CryptoJS.AES.encrypt(bvn, wqkgx).toString(),
      }),
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      },
    )
    .catch((err) => {
      setLoadingBVNVerify(false);
      logUserOut(err?.response?.status);
      customToast(err?.response?.data?.message, ToastType.error);
    });
};
